import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-list-hours-field',
  templateUrl: './list-hours-field.component.html',
  styleUrls: ['./list-hours-field.component.scss']
})
export class ListHoursFieldComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
